<template>
  <div>
    <v-content id="archived-stories-previews">
      <v-container
        white
        fill-height
        fluid
        :class="{'px-0': $vuetify.breakpoint.smAndUp }"
        pt-5
      >
        <v-data-iterator
          v-if="archivedStories.length > 0"
          :items="archivedStories"
          rows-per-page-text="Past data stories"
          :pagination.sync="dataStoryPagination"
          no-data-text="The Data Stories Archive is currently empty"
          content-tag="v-layout"
          row
          wrap
          loading
        >
          <v-toolbar
            slot="header"
            color="secondary"
            flat
          >
            <v-toolbar-title>Data Stories Archive</v-toolbar-title>
          </v-toolbar>
          <v-flex
            slot="item"
            slot-scope="props"
            xs12
            md4
          >
            <v-card>
              <v-card-title primary-title><h4>{{ props.item.story.title }}</h4></v-card-title>
              <v-img
                :src="require(`@/assets/img/datastories/${getTeaserImage(props.item.images)}`)"
                height="125px"
              ></v-img>

              <v-card-text
              >
                <div>
                  <div>{{ props.item.story.teaser }}</div>
                </div>
              </v-card-text>
              <v-btn small flat round color="primary" @click="toggleArchivedStory(props.item.id, props.index, $event)">{{ archivedStoriesButtons[calculateButtonIndex(props.index)] }}</v-btn>
            </v-card>
          </v-flex>
        </v-data-iterator>
      </v-container>
    </v-content>

    <v-content v-show="showArchived">
      <v-container
        white
        fill-height
        fluid
        :class="{'px-0': $vuetify.breakpoint.smAndUp }"
        py-0
      >
        <v-layout row wrap align-center>
          <v-content>
            <data-story id="archived-story-expanded" v-if="showArchived" :datastory="selectArchived()" :archived="showArchived">
            </data-story>
          </v-content>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import DataStory from './DataStory'

export default {
  props: ['archivedStories'],

  data: () => ({
    activeArchived: 0,
    showArchived: false,
    archivedStoriesButtons: [],
    btnLabelCollapsed: 'Read more',
    btnLabelExpanded: 'Show less',
    dataStoryPagination: {
      rowsPerPage: 3,
      page: 1
    }
  }),
  components: {
    DataStory
  },
  methods: {
    toggleArchivedStory (storyId, propsIndex, event) {
      if (this.activeArchived === 0 || this.activeArchived !== storyId) {
        this.activeArchived = storyId
        let btnIndex = this.calculateButtonIndex(propsIndex)
        this.changeButtonLabels(btnIndex)
      } else if (this.activeArchived === storyId) {
        this.activeArchived = 0
      }

      if (this.activeArchived === 0) {
        this.showArchived = false
        this.changeButtonLabels(-1)
      } else {
        this.showArchived = true
        this.$nextTick(() => {
          this.$vuetify.goTo('#archived-story-expanded', {offset: 100, duration: 600, easing: 'easeInOutCubic'})
        })
      }
    },
    changeButtonLabels (btn) {
      let collapsed = this.btnLabelCollapsed
      let expanded = this.btnLabelExpanded
      if (btn === -1) {
        this.archivedStoriesButtons.forEach(function (elem, index) {
          this[index] = collapsed
        }, this.archivedStoriesButtons) // use arr as this
      } else {
        let previousExpanded = this.archivedStoriesButtons.findIndex(function (elem) {
          return elem === expanded
        })
        this.archivedStoriesButtons[previousExpanded] = collapsed
        this.archivedStoriesButtons[btn] = expanded
      }
    },
    // the index provided by the data iterator element only applies to the currently
    // displayed page of the data iterator -> the overall index needs to be calculated
    calculateButtonIndex (propsIndex) {
      let actualItemIndex = (this.dataStoryPagination.page - 1) * this.dataStoryPagination.rowsPerPage + propsIndex
      return actualItemIndex
    },
    selectArchived () {
      let currentlyActive = this.activeArchived

      let selectedStory = this.archivedStories.filter(function (s) {
        return s.id === currentlyActive
      })

      if (selectedStory[0] !== undefined) {
        return selectedStory[0]
      }
    },
    getTeaserImage (images) {
      let teaserImage = images.find(image => image.teaser === true)
      return teaserImage.file
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      let countArchived = this.archivedStories.length
      for (let x = 0; x < countArchived; x++) {
        this.archivedStoriesButtons.push(this.btnLabelCollapsed)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StoryArchive.vue